'use client'

import Link from 'next/link'
import { useEffect } from 'react'

import { useClientLogger } from './lib/use-client-logger'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  const clientLogger = useClientLogger()

  useEffect(() => {
    if (!clientLogger) return
    clientLogger.error(error.message, error)
  }, [error, clientLogger])

  return (
    <html>
      <body>
        <main className="flex h-screen flex-col items-center justify-center gap-2">
          <h1 className="text-2xl">Something went wrong</h1>
          <Link href="/">Go home</Link>
        </main>
      </body>
    </html>
  )
}
